export const setEventList = (state, payload) => {        
    state.list = payload
}


// WEBPACK FOOTER //
// ./src/store/modules/events/mutations.js